var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "section",
        { staticClass: "menu__page line-menu" },
        _vm._l(_vm.menuTop, function(menu) {
          return _vm.menuTop
            ? _c(
                "div",
                { key: menu.id, staticClass: "item" },
                [
                  _c(
                    "nuxt-link",
                    {
                      staticClass: "solid-hover",
                      attrs: { to: menu.link, exact: "" }
                    },
                    [_vm._v(_vm._s(menu.name))]
                  )
                ],
                1
              )
            : _vm._e()
        })
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4de30e02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4de30e02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/about/AboutMenu.vue
// module id = d6Kk
// module chunks = 16 18 19 29 30